import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { supportRequestedForm } from "../../../shared/formObjects/application/supportRequested";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function SupportRequestedComponent({ disabled, data, showEdit, showBack }: any) {
  const formApi = useApiClient("supportRequested");
  const { id } = useApplicationContext();

  return (
    <>
      <BaseApplicationComponent
        formBody={supportRequestedForm}
        headerLabel="Support Requested"
        editPath="supportRequested"
        apiClient={formApi}
        disabled={disabled}
        showInternalNotes={false}
        data={data}
        showBack={showBack}
        showEdit={showEdit}
        print={true}
        id={id}
      />
    </>
  );
}
